/*------------------------------------*\
    CENTRAL APP MASTER 
    
    This file includes the module placeholders system that allows modular 
    binding of custom methods / plugins etc. 
    
    EXAMPLE
    
    <div data-module="example1,example2"></div> 
    
    The above would meet two conditions in the below switch statement.
    
\*------------------------------------*/
var app = (function($) {

	// Global settings
	var settings = {

		// Typeset module settings
		typeset: {
			enabled: true,
			selectors: 'h1, h2, h3, h4, h5, h6, p, ul:not([class]) li, ol:not([class]) li, dt, dd, blockquote, .quote__content, .thumbnail__caption'
		}
	};
	
	// This method will run when the DOM is ready. 
	var init = function() {
		
		// Find any module placeholders 
		var modulePlaceholders = $('[data-module]');
		
		if(modulePlaceholders.any()) {
			
			// Loop each placeholder
			modulePlaceholders.each(function() {
				
				var elem = $(this),
					modules = elem.attr('data-module');
				
				// If any modules found	
				if(modules) {
					
					// Split on the comma 
					modules = modules.split(',');
					
					// Loop each module key
					$.each(modules, function(i, module) {
						
						// Run switch to bind each module to each key
						switch(module) {

							case 'gallery':
								elem.gallery();
								break;

							case 'gallery-thumbs':
								elem.galleryThumbs();
								break;
							
						}
						
					});
				}
			});
		}
		
		// If typeset is enabled
		if(settings.typeset.enabled) {

			// Loop each item and bind it to the module
			$(settings.typeset.selectors).each(function() { 
				$(this).typeSet();
			});
		}

		// Run shim for form validation if required
		if($('html').hasClass('no-formvalidation')) {

			$('head').append('<script src="/site/templates/scripts/webshim.js"></script>');

			setTimeout(function() {

				webshim.setOptions('forms', {
				    replaceValidationUI: true
				});

				webshim.polyfill('forms');
				
			}, 400);
		}
	};
	
	return {
		init: init
	}
	
}(window.$));

// RUN!!
app.init();